import { Component, EventEmitter, Input, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'shared-search-input-select',
  templateUrl: './search-input-select.component.html'
})
export class SearchInputSelectComponent {

  @Input('defaultValue')
  public defaultValue?: any = undefined;

  @Input('label')
  public label: string = '';

  @Input('placeholder')
  public placeholder: string = '';

  @Input('isLoading')
  public isLoading: boolean = false;

  @Input('data')
  public data: any[] = [];

  @Input('display-name-prop')
  public displayNameProp: string = '';

  @Input('selected-text')
  public selectedText: string = '';

  @Input('required')
  public required: boolean = false;

  @Output('onEnter') 
  public onEnter: EventEmitter<string> = new EventEmitter();

  @Output('onDebounce')
  public onDebounce: EventEmitter<string> = new EventEmitter();

  @Output('onSelected')
  public onSelected: EventEmitter<any> = new EventEmitter();

  public debouncer: Subject<string> = new Subject();

  public search: string = '';

  public searched: boolean = true;

  public selected: boolean = false;

  ngOnInit(): void {
    if(this.defaultValue) {
      this.selected = true;
      this.search = this.defaultValue[this.displayNameProp];
    }

    this.debouncer
      .pipe(debounceTime(300))
      .subscribe( value => this.onDebounce.emit(value));
  }

  /**
   * Reset the searched state and emit the search value through the debouncer.
   */
  public onKeyPress(): void {
    this.searched = false;
    this.debouncer.next(this.search);
  }

  /**
   * Emit element to search.
   */
  public onSearch(): void {
    if(this.selected) return;
    this.searched = true;
    this.onEnter.emit(this.search);
  }

  /**
   * Clear textbox and reset element selected.
   */
  public onRemoveSelectedRecord(): void {
    this.selected = false;
    this.searched = true;
    this.search = '';
    this.data = [];
    this.onSelected.emit(undefined);
  }

  /**
   * Emit a event when an element is selected.
   * @param value Element.
   */
  public onSelectedRecord(value: any): void {
    this.search = value[this.displayNameProp];
    if(this.selected) return;
    
    this.selected = true;
    this.onSelected.emit(value);
  }
}